import React, { Component } from "react";
import moment from "moment";

import IntelliportSensorsSettingsForm from "./IntelliportSensorsSettingsForm";
import IntelliportCommandsCreateForm from "./IntelliportCommandsCreateForm";

import { defaultSorter, dateSorter } from "./Helpers";
import IntelliportSensorsModel from "./IntelliportSensorsModel";
import IntelliportCommandsModel from "./IntelliportCommandsModel";
import UserModel from "./UserModel";

import {
    Table,
    Badge,
    Divider,
    Row,
    Col,
    Card,
    Popconfirm,
    Typography,
    message,
    Tag,
    Tooltip,
} from "antd";

class IntelliportSensorsTable extends Component {
    state = {
        children: [],
        filteredInfo: {},
        sortedInfo: {},
        intelliportSensorsSettingsFormData: null,
        intelliportCommandsCreateFormData: null,
    };

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    };

    expandedRowRender(record) {
        return (
            <div>
                <Row>
                    <Col span={6}>
                        <Card title="PID senzoru">{record.pid}</Card>
                    </Col>
                </Row>
            </div>
        );
    }

    render() {
        let { sortedInfo, filteredInfo } = this.state;

        const columns = [
            {
                title: "Lokalita",
                dataIndex: "parkingLocationName",
                key: "parkingLocationName",
                width: 230,
                sorter: (a, b) =>
                    defaultSorter(a.parkingLocationName, b.parkingLocationName),
            },
            {
                title: "Místo",
                dataIndex: "place_id",
                key: "place_id",
                width: 75,
                defaultSortOrder: "ascend",
                sorter: (a, b) => defaultSorter(a.place_id, b.place_id),
            },
            {
                title: "Seriové číslo",
                dataIndex: "serial_number",
                key: "serial_number",
                width: 200,
                sorter: (a, b) =>
                    defaultSorter(a.serial_number, b.serial_number),
            },
            {
                title: "Poslední komunikace",
                dataIndex: "last_communication",
                key: "last_communication",
                width: 180,
                sorter: (a, b) =>
                    dateSorter(a.last_communication, b.last_communication),
                render: (text, record) => {
                    if (
                        record.last_communication === null ||
                        moment(record.last_communication).isSame(moment(0))
                    ) {
                        record.last_communication = moment(0);
                        return (
                            <Badge status="error" text="Nikdy" title="nikdy" />
                        );
                    } else if (
                        moment(record.last_communication).isAfter(
                            moment().subtract(24, "hours")
                        )
                    ) {
                        return (
                            <Badge
                                status="success"
                                text={moment(record.last_communication).format(
                                    "L LTS"
                                )}
                                title="aktivní"
                            />
                        );
                    } else {
                        return (
                            <Badge
                                status="error"
                                text={moment(record.last_communication).format(
                                    "L LTS"
                                )}
                                title="neaktivní"
                            />
                        );
                    }
                },
            },
            {
                title: "Poslední změna stavu",
                dataIndex: "last_parking_status_change",
                key: "last_parking_status_change",
                width: 180,
                sorter: (a, b) =>
                    dateSorter(
                        a.last_parking_status_change,
                        b.last_parking_status_change
                    ),
                render: (text, record) => {
                    return moment(record.last_parking_status_change).format(
                        "L LTS"
                    );
                },
            },
            {
                title: "Stav",
                dataIndex: "parking_status",
                key: "parking_status",
                width: 130,
                sorter: (a, b) =>
                    defaultSorter(a.parking_status, b.parking_status),
                filters: [
                    {
                        text: "Volno",
                        value: 0,
                    },
                    {
                        text: "Obsazeno",
                        value: 1,
                    },
                    {
                        text: "Neznámý stav",
                        value: -1 || null,
                    },
                ],
                filteredValue: filteredInfo.parking_status || null,
                onFilter: (value, record) => {
                    if (value === 2) {
                        return record.parking_status === 2 ||
                            record.parking_status === null
                            ? true
                            : false;
                    } else {
                        return record.parking_status === value ? true : false;
                    }
                },
                render: (text, record) => {
                    if (record.parking_status === 1) {
                        return (
                            <Badge
                                status="error"
                                text={"OBSAZENO"}
                                title="Obsazeno"
                            />
                        );
                    } else if (record.parking_status === 0) {
                        return (
                            <Badge
                                status="success"
                                text={"VOLNO"}
                                title="Volno"
                            />
                        );
                    } else {
                        return (
                            <Badge
                                color="#6d6d6d"
                                text={"Neznámý stav"}
                                title="Neznámý stav"
                            />
                        );
                    }
                },
            },
            {
                title: "Upozornění",
                dataIndex: "reports_enabled",
                key: "reports_enabled",
                width: 130,
                filters: [
                    {
                        text: "ZAPNUTO",
                        value: true,
                    },
                    {
                        text: "VYPNUTO",
                        value: false,
                    },
                ],
                filteredValue: filteredInfo.reports_enabled || null,
                onFilter: (value, record) => {
                    return record.reports_enabled === value ? true : false;
                },
                render: (text, record) => {
                    if (record.reports_enabled === true) {
                        return <Badge status="success" text="ZAPNUTO" />;
                    } else {
                        return (
                            <Badge
                                status="error"
                                text="VYPNUTO"
                                title="Vpořádku"
                            />
                        );
                    }
                },
            },
            {
                title: "Akce",
                key: "Action",
                width: 300,
                render: (text, record) => {
                    if (
                        UserModel.isInRoles([
                            "ADMIN",
                            "INTELLIPORT_SENSORS_WRITE",
                        ])
                    ) {
                        return (
                            <div>
                                <a
                                    onClick={(e) => {
                                        this.setState({
                                            intelliportSensorsSettingsFormData:
                                                record,
                                        });
                                    }}
                                >
                                    Nastavení
                                </a>
                                <Divider type="vertical" />
                                <a
                                    onClick={(e) => {
                                        this.setState({
                                            intelliportCommandsCreateFormData:
                                                record,
                                        });
                                    }}
                                >
                                    <Typography.Text type="warning">
                                        Poslat příkaz
                                    </Typography.Text>
                                </a>
                                <Divider type="vertical" />
                                <Popconfirm
                                    placement="right"
                                    title="Opravdu si přejete tento senzor aktivovat?"
                                    okText="Ano"
                                    cancelText="Ne"
                                    onConfirm={(e) => {
                                        IntelliportCommandsModel.create({
                                            sensor_pid: record.pid,
                                            sensor_serial_number:
                                                record.serial_number,
                                            command_type: "43",
                                            priority: 99,
                                            command_parameters: "AA=1",
                                        });
                                    }}
                                >
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                        }}
                                    >
                                        <Typography.Text type="warning">
                                            Aktivovat
                                        </Typography.Text>
                                    </a>
                                </Popconfirm>
                                <Divider type="vertical" />
                                <Popconfirm
                                    placement="right"
                                    title="Opravdu si přejete tento senzor deaktivovat?"
                                    okText="Ano"
                                    cancelText="Ne"
                                    onConfirm={(e) => {
                                        IntelliportCommandsModel.create({
                                            sensor_pid: record.pid,
                                            sensor_serial_number:
                                                record.serial_number,
                                            command_type: "43",
                                            priority: 99,
                                            command_parameters: "AA=0",
                                        });
                                    }}
                                >
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                        }}
                                    >
                                        <Typography.Text type="warning">
                                            Deaktivovat
                                        </Typography.Text>
                                    </a>
                                </Popconfirm>
                                <Divider type="vertical" />
                                <Popconfirm
                                    placement="right"
                                    title="Opravdu si přejete tento senzor smazat?"
                                    okText="Ano"
                                    cancelText="Ne"
                                    onConfirm={() => {
                                        IntelliportSensorsModel.remove(
                                            record.pid
                                        )
                                            .then(() => {
                                                message.success(
                                                    "Senzor byl odstraněn!"
                                                );
                                                this.props.onRowRemoved();
                                            })
                                            .catch(() => {
                                                message.error(
                                                    "Senzor se nepodařilo smazat!"
                                                );
                                            });
                                    }}
                                >
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                        }}
                                    >
                                        <Typography.Text type="danger">
                                            Smazat
                                        </Typography.Text>
                                    </a>
                                </Popconfirm>
                            </div>
                        );
                    }
                },
            },
        ];

        return (
            <div>
                <Table
                    size="small"
                    rowKey={this.props.rowKey ? this.props.rowKey : "pid"}
                    loading={this.props.loading ? this.props.loading : false}
                    columns={columns}
                    dataSource={this.props.data}
                    style={{ border: "0px" }}
                    scroll={{ x: 400 }}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize:
                            localStorage.getItem("table_pageSize") !== undefined
                                ? parseInt(
                                      localStorage.getItem("table_pageSize")
                                  )
                                : 10,
                        onShowSizeChange: (current, size) => {
                            localStorage.setItem("table_pageSize", size);
                        },
                    }}
                    onChange={this.handleChange}
                    expandedRowRender={this.expandedRowRender.bind(this)}
                    rowSelection={
                        this.props.rowSelection !== undefined
                            ? this.props.rowSelection
                            : null
                    }
                />

                <IntelliportSensorsSettingsForm
                    type="modal"
                    modalVisible={
                        this.state.intelliportSensorsSettingsFormData === null
                            ? false
                            : true
                    }
                    initialValues={
                        this.state.intelliportSensorsSettingsFormData
                    }
                    onModalCancel={(form) => {
                        form.resetFields();
                        this.setState({
                            intelliportSensorsSettingsFormData: null,
                        });
                    }}
                    onSuccess={(form, values) => {
                        IntelliportSensorsModel.update(
                            this.state.intelliportSensorsSettingsFormData.pid,
                            values
                        )
                            .then(() => {
                                message.success("Změna byla uložena!");
                                form.resetFields();
                                this.setState({
                                    intelliportSensorsSettingsFormData: null,
                                });
                                if (this.props.onAnyFormSuccess) {
                                    this.props.onAnyFormSuccess();
                                }
                            })
                            .catch((err) => {
                                message.warning(
                                    "Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby."
                                );
                            });
                    }}
                />
                <IntelliportCommandsCreateForm
                    type="modal"
                    modalVisible={
                        this.state.intelliportCommandsCreateFormData === null
                            ? false
                            : true
                    }
                    initialValues={this.state.intelliportCommandsCreateFormData}
                    onModalCancel={(form) => {
                        form.resetFields();
                        this.setState({
                            intelliportCommandsCreateFormData: null,
                        });
                    }}
                    onSuccess={(form, values) => {
                        console.log("values", values);
                        IntelliportCommandsModel.create(values)
                            .then(() => {
                                message.success("Příkaz byl odeslán!");
                                form.resetFields();
                                this.setState({
                                    intelliportCommandsCreateFormData: null,
                                });
                                if (this.props.onAnyFormSuccess) {
                                    this.props.onAnyFormSuccess();
                                }
                            })
                            .catch((err) => {
                                message.warning(
                                    "Příkaz se nepodařilo odeslat. Zkontrolujte spravnou funkčnost služby."
                                );
                            });
                    }}
                />
            </div>
        );
    }
}

export default IntelliportSensorsTable;



// WEBPACK FOOTER //
// ./src/components/IntelliportSensorsTable.js